export default __webpack_public_path__ + "static/media/page62.bfd1f6a7.png";